// CSS
import "@/polishop/panela-velha/styles.css";

// JS
// import "htmx.org";
import "@justinribeiro/lite-youtube";

// Swiper
const swiperEl = document.querySelector("swiper-container");
const swiperParams = {
  slidesPerView: 1,
  slidesPerGroup: 1,
  pagination: false,
  // loop: true,
  breakpoints: {
    640: {
      slidesPerView: 4,
      slidesPerGroup: 4,
      pagination: false,
    },
  },
  injectStyles: [
    `
      .swiper-button-next,
      .swiper-button-prev {
        background-color: rgb(150 24 17);
        padding: 8px 16px;
        border-radius: 100%;
        border: 0;
        color: white;
        margin-top:10%;
        transform: scale(0.65);
      }
      .swiper-button-next {
        padding-left: 18px;
      }
      .swiper-button-prev {
        padding-right: 18px;
      }
      .swiper-button-next > svg,
      .swiper-button-prev > svg {
        transform: scale(0.65);
      }
  `,
  ],
  on: {
    init() {
      // ...
    },
  },
};

Object.assign(swiperEl, swiperParams);
if (swiperEl) {
  swiperEl.initialize();
  swiperEl.addEventListener('swiperslidechange', (event) => {
    const { detail } = event;
    if (!detail || !detail.length) return;
    const { activeIndex } = detail[0];
    const array = document.querySelectorAll(".inpulse-step");
    array.forEach((element, index) => {
      if (index === activeIndex) {
        element.classList.add("inpulse-text-[#fce973]");
        element.classList.add("inpulse-border-[#fce973]");
        element.classList.remove("inpulse-border-[#961811]");
      } else {
        element.classList.remove("inpulse-text-[#fce973]");
        element.classList.remove("inpulse-border-[#fce973]");
        element.classList.add("inpulse-border-[#961811]");
      }
    });
  });
}

// iFrame Resizer

let interval;

function sendHeight() {
  if (document.getElementById("lp")) {
    const height = document.body.scrollHeight;
    window.parent.postMessage({ frameHeight: height }, "*");
  } else {
    clearInterval(interval);
    interval = null;
  }
}

// Send the height when the DOM is fully loaded
document.addEventListener("DOMContentLoaded", sendHeight);

// Update the height at an interval
interval = setInterval(sendHeight, 500);

// Optionally, update the height when the window is resized
window.addEventListener("resize", sendHeight);